import { render, staticRenderFns } from "./ExportPendingData.vue?vue&type=template&id=0ac756b6&"
import script from "./ExportPendingData.vue?vue&type=script&lang=js&"
export * from "./ExportPendingData.vue?vue&type=script&lang=js&"
import style0 from "./ExportPendingData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports